/**
 * lib/helpApi.js — Phase 84.15
 *
 * Thin fetch layer for the /api/help/* endpoints. Isolated here so the
 * page + components don't repeat auth-header + JSON boilerplate.
 */
import { supabase } from '@/lib/supabaseClient';

const API = process.env.REACT_APP_BACKEND_URL;

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchManifest() {
  const headers = await authHeaders();
  const r = await fetch(`${API}/api/help/manifest`, { headers });
  if (!r.ok) throw new Error(`manifest fetch ${r.status}`);
  return r.json();
}

export async function fetchArticle(slug) {
  const headers = await authHeaders();
  const r = await fetch(`${API}/api/help/articles/${encodeURIComponent(slug)}`, { headers });
  if (!r.ok) {
    const err = new Error(`article fetch ${r.status}`);
    err.status = r.status;
    throw err;
  }
  return r.json();
}

export async function patchArticle(slug, patch) {
  const headers = { ...(await authHeaders()), 'Content-Type': 'application/json' };
  const r = await fetch(`${API}/api/help/articles/${encodeURIComponent(slug)}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(patch),
  });
  if (!r.ok) {
    let detail = '';
    try { detail = (await r.json())?.detail || ''; } catch { /* ignore */ }
    const err = new Error(detail || `patch failed (${r.status})`);
    err.status = r.status;
    throw err;
  }
  return r.json();
}
